module.exports = __webpack_public_path__ + "static/media/services_bg.793bd2cf.jpg";